import {Text, View, StyleSheet} from "react-native";
import React from "react";

interface IJobRowDetailProps {
    jobRow: any;
}

const JobRowDetail = (props: IJobRowDetailProps) => {
    const {jobRow} = props;
    return <View style={{flexDirection: "row"}}>
        <View style={{flexDirection: "row", width: 250}}>
            <Text style={styles.headText}>Car Part:</Text>
            <Text style={[styles.subHeadText, {marginLeft: 10, fontWeight: "bold"}]}>{jobRow?.carPart?.name ?? "N/A"}</Text>
        </View>
        <View style={{flexDirection: "row"}}>
            <View>
                <Text style={styles.headText}>Issues: </Text>
                <Text style={styles.headText}>Fixes: </Text>
            </View>
            <View style={{flexDirection: "row"}}>
                {!!jobRow && !!jobRow.subJobRow && !!jobRow.subJobRow.length ? jobRow.subJobRow.map((sjr, i) => {
                    return <View style={{marginHorizontal: 5}} key={i}>
                        <Text key={i}
                              style={[styles.subHeadText, {fontWeight: "bold"}]}>{sjr.issue.name} </Text>
                        {sjr.fixes.map((fix, i) => {
                            return <Text key={i} style={styles.subHeadText}>{fix.name} </Text>
                        })}
                    </View>
                }) : null}
            </View>
        </View>
    </View>
}

const styles = StyleSheet.create({
    headText: {
        color: '#200E36',
        fontWeight: 'bold',
        fontFamily: 'Roboto',
    },
    subHeadText: {
        color: '#555555',
        fontFamily: 'Roboto'
    },
});

export default JobRowDetail